import React from "react";
import { string } from "prop-types";

const LeftArrowButton = ({ color = "#007bbd", color2 = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" width="42" height="42">
    <circle id="Ellipse_68" opacity="0.7" enableBackground="new " cx="21" cy="21" r="21" fill={color} />
    <g id="Path_51">
      <path
        fill={color2}
        d="M24.5,29.5c-0.256,0-0.512-0.098-0.707-0.293L15.086,20.5l8.707-8.707c0.391-0.391,1.023-0.391,1.414,0
		s0.391,1.023,0,1.414L17.914,20.5l7.293,7.293c0.391,0.391,0.391,1.023,0,1.414C25.012,29.402,24.756,29.5,24.5,29.5z"
      />
    </g>
  </svg>
);

LeftArrowButton.propTypes = {
  color: string,
  color2: string,
};

export default LeftArrowButton;
